export default __webpack_public_path__ + "static/media/types-of-bolts.cb975813.webp";